import {useParams, Outlet, Link} from "react-router-dom";
import { HouseholdLayout } from '@/components/layouts/HouseholdLayout.jsx';
import { PageHeader } from '@/components/PageHeader';
import { CrudTable } from '@/components/CrudTable';
import {useDeleteUserMutation, useGetUsersQuery} from "@/features/users/api.js";
import {capitalizeFirstLetter} from "@/utils/strings.js";
import {useCrudHouseholdMutation} from "@/hooks/useCrudHouseholdMutation.js";
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import {Button, Stack} from "@mui/joy";
import {Invitations} from "@/features/users/components/Invitations.jsx";
import AddIcon from "@mui/icons-material/Add";
import {ConfirmAction} from "@/components/ConfirmAction.jsx";
import { useState } from 'react';
import { Input } from '@mui/joy';
import SearchIcon from '@mui/icons-material/Search';

export function UsersPage() {
  const { householdId } = useParams();
  const useQuery = () => useGetUsersQuery({ householdId });
  const useDelete = useCrudHouseholdMutation(householdId, useDeleteUserMutation);
  const [search, setSearch] = useState('');

  const options = {
    names: {
      singular: 'user',
      plural: 'users',
    },

    columns: [
      { label: 'Email', getter: (row) => row.email || row.id},
      { label: 'Role', getter: (row) => capitalizeFirstLetter(row.role) },
    ],

    options: {
      searchable: false,
      externalSearch: true,
    },

    actions: {
      list: useQuery,
      get: ':id',
      extra: [{
        type: 'delete',
        render: (row) =>
          <ConfirmAction key="revoke" id={row.id} name={row.email} useAction={useDelete} icon={<BlockRoundedIcon />} texts={{
            tooltip: "Revoke access",
            title: "Revoke access?",
            message: `Are you sure you want to revoke access for ${row.email}?`,
            action: 'Revoke',
          }} actionColor="danger" />
      }],
    },
  };

  return (
    <HouseholdLayout>
      <Stack gap={2} direction="column">
        <PageHeader title="Users">
          <Input
            sx={{ width: '250px' }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search"
            startDecorator={<SearchIcon/>}
          />
          <Link to="invite"><Button startDecorator={<AddIcon/>}>Invite user</Button></Link>
        </PageHeader>      
        <Stack gap={3} direction="column">
          <CrudTable {...options} externalSearch={search} />
          <Invitations />              
        </Stack>
      </Stack>
      <Outlet />
    </HouseholdLayout>
  );
}
